"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  ABOUT_US: 'aboutUs',
  ADMINISTRATION: 'administration',
  CULTURE: 'culture',
  PEOPLE: 'people',
  WHATS_THE_BUZZ: 'whatsTheBuzz',
  FLIGHT_GUIDE: 'flightGuide',
  OPPORTUNITIES: 'opportunities'
};
exports.default = _default;